import * as React from 'react'
import { PageHeaderComponent } from './PageHeaderComponent'
import { usePageHeader, type PageHeaderProps } from './usePageHeader'

/**
 * PageHeader - wrapper component that combines the hook and presentation layer.
 * Use this for backward compatibility with existing code.
 */
function PageHeader(props: PageHeaderProps): React.ReactElement {
  const headerProps = usePageHeader(props)
  return <PageHeaderComponent {...headerProps} />
}

export { PageHeader }
export type { PageHeaderProps }
